export default __webpack_public_path__ + "static/media/D2022_05_30_Mary_Cries_Toronto.8bc164e1.jpg";